import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import './plugins/amplify-vue2';
import App from './App.vue';
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/style/global.css';

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/amplify-\w*/];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
